import { skipToken } from "@reduxjs/toolkit/query";
import type { FC } from "react";
import { useProjectByIdQuery } from "../../api/entities/project.js";
import { renderCrumbLabel } from "../../app/navigation/crumbLabel.js";

/** Breadcrumb label for the project (job opening / training) detail pages. */
export const ProjectNameCrumbLabel: FC<{ projectId: string | undefined }> = ({
  projectId,
}) => {
  const result = useProjectByIdQuery(projectId ?? skipToken);
  return renderCrumbLabel({
    hasValidId: projectId !== undefined,
    result,
    buildText: (project) => project.name,
    fallbackText: "Project",
  });
};
